import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataShape {
  id: string; // or number, depending on your data
  attributes: {
    ShapeCode: string;
    ShapeName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const ShapeMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  ////////////////  Function For 8 Start /////////////////
  const [shape, setShape] = useState({
    ShapeCode: '',
    ShapeName: '',
    dis: 'Continue'
  });

  // Fetch Data from API Start
  const [shapedata, setShapedata] = useState<RowDataShape[]>([]);
  const [shapemeta, setShapemeta] = useState<MetaData>();
  const [disShape, setDisShape] = useState([]);
  const [editedRowIdsShape, setEditedRowIdsShape] = useState<string[]>([]);
  const [editedRowIdShape, setEditedRowIdShape] = useState<string>('');
  const [editedDataShape, setEditedDataShape] = useState<
    Record<string, Partial<RowDataShape['attributes']>>
  >({});
  const [selectedBuyershape, setSelectedBuyershape] = useState('Continue');
  const handleBuyerChangeshape = value => {
    setSelectedBuyershape(value);
  };
  const [isLoading8, setIsLoading8] = useState(false);
  useEffect(() => {
    fetchData8();
  }, [selectedBuyershape]);
  const fetchData8 = async () => {
    if (isLoading8) {
      return;
    }
    setIsLoading8(true);
    let disFilter = '';
    if (selectedBuyershape.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyershape}`;
    }
    if (selectedBuyershape == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/shape-masters?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/shape-masters?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/shape-masters?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();
    const response2 = await fetch(`${globalIP}/api/shape-masters`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/shape-masters?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisShape(allData2);
    setShapemeta(jsonmeta.meta);
    setShapedata(allData);
    setIsLoading8(false);
  };
  const processInputRef = useRef(null);
  const handleEditRowShape = rowData => {
    setShape({ ...rowData.attributes });
    setEditedRowIdShape(rowData.id);
    setEditedRowIdsShape(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataShape(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetShape = () => {
    setShape({
      ShapeCode: '',
      ShapeName: '',
      dis: 'Continue'
    });
  };
  const handleCancelShape = rowData => {
    resetShape();
    setEditedRowIdShape('');
    setEditedRowIdsShape('');
  };
  const url8 = `${globalIP}/api/shape-masters`;
  const submit8 = async e => {
    const trimmedShapeName = shape.ShapeName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

    // Validate the shape name input
    if (trimmedShapeName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please enter a valid {label[0]?.attributes.Shape}.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }

    if (specialCharPattern.test(trimmedShapeName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Shape} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }

    try {
      const { data: shapee } = await axios.get(
        `${globalIP}/api/shape-masters?filters[ShapeName][$eqi]=${trimmedShapeName}`
      );
      const { data: shapecode } = await axios.get(`${globalIP}/api/shape-masters?populate=*`);
      const nextCode = shapecode.meta.pagination.total + 1;
      if (shapee.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Shape} {shape.ShapeName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }

      e.preventDefault(); // Prevent default form submission behavior
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...shape,
          ShapeName: trimmedShapeName,
          ShapeCode: `SAP-${nextCode.toString().padStart(3, '0')}`
        })
      );

      // Make the API call to save the new shape
      const response = await fetch(url8, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData8(); // Wait for data to be fetched before logging
        console.log(shape);

        toaster.push(
          <Message showIcon type="success">
            Data saved successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving shape', error);
    }

    // Reset the shape state
    setShape({
      ShapeCode: '',
      ShapeName: '',
      dis: 'Continue'
    });
  };

  //  Fetch Data from API End
  const handleInputChange8 = (inputName, value, index) => {
    setShape({ ...shape, [inputName]: value });
  };
  const handleShapec = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...shapedata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/shape-masters/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData8();
        toaster.push(
          <Message showIcon type="success">
            {mat} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleShapeD = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...shapedata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/shape-masters/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData8();
        toaster.push(
          <Message showIcon type="success">
            {mat} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowShape = async () => {
    try {
      if (!shape) {
        console.error('Row data not found.');
        return; // Exit if row data is not found
      }

      const updatedShapeName = shape?.ShapeName?.trim() || '';
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      // Validate the updated shape name
      if (!updatedShapeName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid {label[0]?.attributes.Shape}.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution if validation fails
      }

      if (specialCharPattern.test(updatedShapeName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.Shape} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution if validation fails
      }

      const { data: shapename } = await axios.get(
        `${globalIP}/api/shape-masters?filters[ShapeName][$eqi]=${updatedShapeName}&filters[id][$ne]=${editedRowIdShape}`
      );
      if (shapename.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Shape} {updatedShapeName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // const updatedRowData: RowDataShape = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataShape[rowId],
      //     ShapeName: updatedShapeName
      //   }
      // };

      // Send the PUT request to update the shape
      const response = await fetch(`${globalIP}/api/shape-masters/${editedRowIdShape}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...shape, ShapeName: updatedShapeName } })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchData8(); // Refresh the data after successful save
        resetShape('');
        setEditedRowIdShape('');
        setEditedDataShape(prevData => ({
          ...prevData,
          [editedRowIdShape]: { ...shape, ShapeName: updatedShapeName } // Ensure UI updates correctly
        }));
        setEditedRowIdsShape(prevRowIds => [...new Set([...prevRowIds, editedRowIdShape])]);
      } else {
        console.error('Failed to save data');
        // Optionally, add user feedback for failed save
        toaster.push(
          <Message showIcon type="error">
            Failed to save {label[0]?.attributes.Shape}. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
      // Provide user feedback for unexpected errors
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving {label[0]?.attributes.Shape}. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const handleSaveRowShape1 = async (rowId: string) => {
    try {
      const rowData = shapedata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return; // Exit if row data is not found
      }

      const updatedShapeName = editedDataShape[rowId]?.ShapeName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      const { data: shapename } = await axios.get(
        `${globalIP}/api/shape-masters?filters[ShapeName][$eqi]=${updatedShapeName}&filters[id][$ne]=${rowId}`
      );
      // Validate the updated shape name
      if (!updatedShapeName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid {label[0]?.attributes.Shape}.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution if validation fails
      }

      if (specialCharPattern.test(updatedShapeName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.Shape} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution if validation fails
      }

      const existingHscode = shapedata.find(
        item => item.attributes.ShapeName.toLowerCase() === updatedShapeName.toLowerCase()
      );
      if (shapename.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Shape} {updatedShapeName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      const updatedRowData: RowDataShape = {
        ...rowData,
        attributes: {
          ...rowData.attributes,
          ...editedDataShape[rowId],
          ShapeName: updatedShapeName
        }
      };

      // Send the PUT request to update the shape
      const response = await fetch(`${globalIP}/api/shape-masters/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchData8(); // Refresh the data after successful save
        setEditedRowIdsShape(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        console.error('Failed to save data');
        // Optionally, add user feedback for failed save
        toaster.push(
          <Message showIcon type="error">
            Failed to save {label[0]?.attributes.Shape}. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
      // Provide user feedback for unexpected errors
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving {label[0]?.attributes.Shape}. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const handleInputChangeShape = (rowId, fieldName, value) => {
    setEditedDataShape(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...shapedata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 8 End /////////////////
  ////////////////  Searching For 8 Start /////////////////
  const [searchQuery8, setSearchQuery8] = useState('');
  const [filterStatus8, setFilteredStatus8] = useState('Continue');
  const handleSearch8 = value => {
    setSearchQuery8(value);
  };
  const [shapeFilterData, setShapeFilterData] = useState([]);

  useEffect(() => {
    const shapeFilterData = shapedata
      .slice()
      .reverse()
      .filter(item => {
        const ShapeName = item.attributes.ShapeName ? item.attributes.ShapeName.toLowerCase() : '';
        return ShapeName.includes(searchQuery8.toLowerCase());
      });
    setShapeFilterData(shapeFilterData);
  }, [shapedata, filterStatus8, searchQuery8]);
  ////////////////  Searching For 8 End /////////////////
  return (
    <>
      <Form.ControlLabel>
        <b>{label[0]?.attributes.Shape}</b>
      </Form.ControlLabel>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="ShapeName"
            name="ShapeName"
            style={{ width: '180%' }}
            autoComplete="off"
            ref={processInputRef}
            value={shape && shape.ShapeName ? shape.ShapeName : ''}
            onChange={value => handleInputChange8('ShapeName', value, 0)}
            onPressEnter={submit8}
          />
          {editedRowIdShape ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowShape}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit8}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyershape}
            onChange={handleBuyerChangeshape}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery8} onChange={handleSearch8} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={shapeFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading8}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr. No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.Shape}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsShape.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataShape[rowData.id]?.ShapeName || ''}
              //     onChange={value => handleInputChangeShape(rowData.id, 'ShapeName', value)}
              //   />
              // ) : (
              rowData.attributes.ShapeName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsShape.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowShape(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowShape(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelShape}
                  // onClick={() =>
                  //   setEditedRowIdsShape(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowShape(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Shape"
                      description="Are you sure you want to continue this Shape?"
                      onConfirm={() => handleShapec(rowData.id, rowData.attributes.ShapeName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleShapec(rowData.id, rowData.attributes.ShapeName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Shape"
                      description="Are you sure you want to discontinue this Shape?"
                      onConfirm={() => handleShapeD(rowData.id, rowData.attributes.ShapeName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleShapeD(rowData.id, rowData.attributes.ShapeName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{shapeFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default ShapeMaster;
